// extracted by mini-css-extract-plugin
export default {"img":"userAvatar_img__D8S4m"};